<div class="h100 labeling__review-container">
    <review-item-feed class="labeling__image-feed"></review-item-feed>
    <div class="labeling__review-body">
        <review-item-header></review-item-header>
        <review-image class="labeling__review-image" [privilegesOnTask]="privilegesOnTask"></review-image>
    </div>
</div>
